/**
 * @generated SignedSource<<0b2272b642f917314b4a7a4db9654a86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type unclaimDeviceMutation$variables = {
  connections: ReadonlyArray<string>;
  deviceNodeId: string;
};
export type unclaimDeviceMutation$data = {
  readonly unclaimDevice: {
    readonly accessPoint: {
      readonly id: string;
    } | null;
    readonly attachment: {
      readonly id: string;
    } | null;
    readonly battery: {
      readonly id: string;
    } | null;
    readonly controller: {
      readonly id: string;
    } | null;
    readonly dock: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
    readonly gimbal: {
      readonly id: string;
    } | null;
    readonly sensor: {
      readonly id: string;
    } | null;
    readonly vehicle: {
      readonly id: string;
    } | null;
  } | null;
};
export type unclaimDeviceMutation = {
  response: unclaimDeviceMutation$data;
  variables: unclaimDeviceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deviceNodeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "deviceNodeId",
    "variableName": "deviceNodeId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "filters": null,
    "handle": "deleteEdge",
    "key": "",
    "kind": "ScalarHandle",
    "name": "id",
    "handleArgs": [
      {
        "kind": "Variable",
        "name": "connections",
        "variableName": "connections"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "unclaimDeviceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UnclaimDevice",
        "kind": "LinkedField",
        "name": "unclaimDevice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccessPoint",
            "kind": "LinkedField",
            "name": "accessPoint",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "attachment",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Battery",
            "kind": "LinkedField",
            "name": "battery",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Controller",
            "kind": "LinkedField",
            "name": "controller",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dock",
            "kind": "LinkedField",
            "name": "dock",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Sensor",
            "kind": "LinkedField",
            "name": "sensor",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Vehicle",
            "kind": "LinkedField",
            "name": "vehicle",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Gimbal",
            "kind": "LinkedField",
            "name": "gimbal",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "unclaimDeviceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UnclaimDevice",
        "kind": "LinkedField",
        "name": "unclaimDevice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccessPoint",
            "kind": "LinkedField",
            "name": "accessPoint",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "attachment",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Battery",
            "kind": "LinkedField",
            "name": "battery",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Controller",
            "kind": "LinkedField",
            "name": "controller",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dock",
            "kind": "LinkedField",
            "name": "dock",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Sensor",
            "kind": "LinkedField",
            "name": "sensor",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Vehicle",
            "kind": "LinkedField",
            "name": "vehicle",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Gimbal",
            "kind": "LinkedField",
            "name": "gimbal",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f71ad0e1c5c57dea9e3dd80936f597bd",
    "id": null,
    "metadata": {},
    "name": "unclaimDeviceMutation",
    "operationKind": "mutation",
    "text": "mutation unclaimDeviceMutation(\n  $deviceNodeId: ID!\n) {\n  unclaimDevice(deviceNodeId: $deviceNodeId) {\n    accessPoint {\n      id\n    }\n    attachment {\n      id\n    }\n    battery {\n      id\n    }\n    controller {\n      id\n    }\n    dock {\n      id\n    }\n    sensor {\n      id\n    }\n    vehicle {\n      id\n    }\n    gimbal {\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "6fbb40954dcc3dd299f03cd4db0d6a03";

export default node;
